export const DefaultPageSizeOptions = [15, 25, 50, 100, 200];

export const MAX_AMOUNT_OF_NON_VIRTUALIZED_COLUMNS = 25;
